import axios from 'axios';
import { get, post, put, downloadBlob } from './client';

export function getYieldUploadUrl(growerId, fileName) {
  return post(`/growers/yield/upload/${growerId}/get-signed-upload-url`, {
    fileName,
  });
}

export function uploadYieldToS3(signedUrl, file, onProgress) {
  return axios.put(signedUrl, file, {
    headers: { 'Content-Type': 'application/zip' },
    onUploadProgress: (progressEvent) => onProgress(file.name, progressEvent),
  });
}

export function uploadYieldToAgi(growerId, fileUrl, fileName) {
  return post(`/${growerId}/yield/conversions`, {
    fileUrl,
    fileName,
  });
}

export function getYieldDownloadUrl(growerId, fileName) {
  return post(`/growers/yield/upload/${growerId}/get-signed-url`, {
    fileName,
  });
}

export function reAssociateYield(growerId, year, aaids) {
  return post(`/growers/${growerId}/yield/${year}/associate`, { aaids });
}

export function sendCropToYieldClean(growerId, year, fields) {
  return post(`/growers/${growerId}/yield/${year}/clean`, {
    fieldCrops: fields.map((field) => ({
      fieldName: field.fieldName,
      aaid: field.aaid,
      crop: field.crop,
    })),
  });
}

export function updateFieldCrop(growerId, year, newCrop, fields) {
  return put(`/growers/${growerId}/yield/${year}`, {
    fieldCropMap: fields.map((field) => ({
      aaid: field.aaid,
      crop: field.harvestedCrop,
      ...(newCrop && { newCrop }),
    })),
  });
}

export function getYieldStats(growerId, aaid, crop, year) {
  return get(`/growers/${growerId}/yield/stats/${aaid}/${crop}/${year}`);
}

export function postCalibrate(fieldAverages, growerId, year) {
  return post(
    `/growers/${growerId}/yield/${year}/post-calibrate`,
    fieldAverages,
  );
}

export function downloadYieldPdfs(growerId, year, aaids) {
  return downloadBlob(`/yield/${growerId}/pdf/${year}`, aaids);
}

export function setYieldApproval(aaid, growerID, user, accepted) {
  return post(`/yield/setyieldApproval/${growerID}/${aaid}/${user}`, [
    accepted,
  ]);
}

export function getYieldData(growerId, year, signal) {
  return get(`/growers/${growerId}/yield/${year}/raw`, { signal });
}
